import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Image } from '../gadgets';

const {img}=Image
const Profile=()=> {
  return (
    <Card sx={{ maxWidth: 345,textAlign:'center' ,margin: 'auto',}}>
      <CardMedia
        sx={{ height: 300 }}
        image={img}
        title="kenneth"
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
        I am Kenneth Agbo, a Nigerian and the brain behind “Kenneth arts” . 

I have been drawing and designing artistic works for over 4 years . I am passionate and loves what I do 

Aside drawing , I am also a student of the great citadel of learning , the Institute of management and Technology Enugu , currently in my first year of the Higher National Diploma program . 

Spare a few seconds and check out some of my recent works on this website and get in touch if you require my services including purchasing ready made arts ; to add warmth and colour to your space/wall/room, to create picture memories , to draw yourself or your dear ones including your favourite celebrities , and many more 

Client satisfaction is our priority
        </Typography>
        <br />
        <br />
        <br />
          <blockquote style={{textAlign:'end'}}>"He who cherish artwork , cherish nature".</blockquote>

      </CardContent>
    
    </Card>
  );
}
export default Profile;